import { Action, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '../../Types/user';
import { getUsers } from '../actions/userActions';
import { RootState } from '../store';

interface FoldersState {
  users: User[];
  isLoading: boolean;
  searchQuery: string;
  searchSelected: boolean;
}

const initialState: FoldersState = {
  users: [],
  isLoading: false,
  searchQuery: '',
  searchSelected: false,
};

// Define the type for the rejected action
interface RejectedAction extends Action {
  payload: string;
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSearchSelected: (state, action: PayloadAction<boolean>) => {
      state.searchSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, action: PayloadAction<User[]>) => {
        const users = action.payload;
        state.users = users;
        state.isLoading = false;
      })
      .addMatcher(
        (action: Action): action is RejectedAction =>
          action.type.startsWith('users/') && action.type.endsWith('/rejected'),
        (state) => {
          state.isLoading = false;
        }
      );
  },
});

export const { setIsLoading, setSearchQuery, setSearchSelected } = usersSlice.actions;

export const selectUsers = (state: RootState) => state.users;

export default usersSlice.reducer;
